import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "../../../../components/ui/dropdown-menu";
import { Button } from "../../../../components/ui/button";
import { MoreHorizontal } from "lucide-react";
import ConfirmationModal from "../../../../components/app/shared/CustomModal";
import { manualCapture, updateCombinedServiceJob } from "../../../../apiManager/admin/JobsManagement";
import React, { useState } from 'react'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "../../../../components/ui/dialog";
import api from "../../../../apiManager/api";

const Action = ({ row }) => {
  const [showCancelModal, setShowCancelModal] = useState(false); //
  const [jobId, setJobId] = useState(''); //
  const [shovelerId, setShovelerId] = useState(''); //
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [loadingJobId, setLoadingJobId] = useState(null);
  const [chat, setChat] = useState(undefined);


  const fetchChats = async (id) => {
    console.log("Id", id)
    const url = "/job/admin/getchats/" + id
    const res = await api.get(url);
    console.log("chat res", res)
    const { data } = res.data;
    if (!data.length) {
      alert("No chat history !");
      return;
    }
    setChat(data);
  }
  const handleCancel = async (type) => {
    if (
      !window.confirm(
        type === "shoveller"
          ? "Cancel job as shoveller?"
          : "Cancel job permanently?"
      )
    )
      return;

    const jobId = row.original._id;
    const shovellerId = row.original.ShovelerInfo?.[0]?.ShovelerId?._id;

    await updateCombinedServiceJob(jobId, {
      action: "cancel",
      by: type === "shoveller" ? "shoveller" : "admin",
      shovellerId,
    });

    window.location.reload();
  };

  const handleCapture = async () => {
    try {

      const res = await manualCapture(jobId, shovelerId, 'admin');
      if (res && res.error) {
        setJobId('');
        setShovelerId('');
        return
      }

      alert('Payment Captured Successfully');
      setShowCancelModal(false); // Close the modal before performing the action
    } catch (error) {
      console.error("Error capturing payment:", error);
      // setError(error.message || "An error occurred while capturing payment");
    }
    setJobId('');
    setShovelerId('');
  }

  const handleManualCaptureClick = (row) => {
    setShowCancelModal(true);
    setJobId(row.original._id);
    setShovelerId(row.original.ShovelerInfo?.[0]?.ShovelerId?._id);
  }

  const handleFetchStripeInfo = async (job) => {
    if (!job.paymentIntentId) {
      // Ideally show a toast here, but for now alert or log
      console.warn("No payment intent ID for job", job._id);
      return;
    }

    setLoadingJobId(job._id);
    try {
      // Backend expects paymentIntent in query params even for POST
      const response = await api.post(`/job/fetchStripeDetails?paymentIntent=${job.paymentIntentId}`);
      setSelectedPayment(response.data);
      setIsDialogOpen(true);
    } catch (error) {
      console.error("Error fetching stripe details:", error);
    } finally {
      setLoadingJobId(null);
    }
  };
  const renderPaymentDialog = () => {
    if (!selectedPayment) return null;

    const { id, amount, status, capture_method, amount_received, latest_charge, currency } = selectedPayment;

    // Calculations based on latest_charge
    const captured = latest_charge?.amount_captured || 0;
    const refunded = latest_charge?.amount_refunded || 0;
    const netSpent = captured - refunded;
    const remaining = amount - amount_received; // Amount yet to be received/captured

    return (
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Stripe Payment Details</DialogTitle>
            <DialogDescription>
              Detailed information for Payment Intent: {id}
            </DialogDescription>
          </DialogHeader>

          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col space-y-1">
                <span className="text-sm font-medium text-muted-foreground">Status</span>
                <span className={`text-sm font-semibold capitalize ${status === 'succeeded' ? 'text-green-600' : 'text-yellow-600'}`}>
                  {status}
                </span>
              </div>
              <div className="flex flex-col space-y-1">
                <span className="text-sm font-medium text-muted-foreground">Capture Method</span>
                <span className="text-sm capitalize">{capture_method?.replace('_', ' ')}</span>
              </div>
            </div>

            <div className="border-t pt-4">
              <h4 className="mb-3 text-sm font-semibold text-gray-900">Financial Breakdown ({currency?.toUpperCase()})</h4>
              <div className="space-y-3">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Total Authorized Amount</span>
                  <span className="text-sm font-medium">${(amount / 100).toFixed(2)}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Amount Received</span>
                  <span className="text-sm font-medium text-green-600">${(amount_received / 100).toFixed(2)}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-600">Amount Captured</span>
                  <span className="text-sm font-medium">${(captured / 100).toFixed(2)}</span>
                </div>
                {refunded > 0 && (
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-red-600">Amount Refunded</span>
                    <span className="text-sm font-medium text-red-600">-${(refunded / 100).toFixed(2)}</span>
                  </div>
                )}
                <div className="border-t border-dashed pt-2 mt-2 flex justify-between items-center">
                  <span className="text-sm font-bold text-gray-900">Net Spent</span>
                  <span className="text-sm font-bold text-gray-900">${(netSpent / 100).toFixed(2)}</span>
                </div>
              </div>
            </div>

            {latest_charge && (
              <div className="bg-gray-50 p-3 rounded-md text-xs text-gray-500 mt-2">
                <p>Latest Charge ID: {latest_charge.id}</p>
                <p>Payment Method: {latest_charge.payment_method_details?.type} - {latest_charge.payment_method_details?.card?.brand} •••• {latest_charge.payment_method_details?.card?.last4}</p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  };
  return (
    <Dialog>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant='ghost'
            className='flex h-8 w-8 p-0 data-[state=open]:bg-muted'
          >
            <MoreHorizontal className='h-4 w-4' />
            <span className='sr-only'>Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end' className='w-max my-1'>
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuItem
            onClick={() => handleManualCaptureClick(row)}
            className="bg-gray-300 hover:bg-gray-600 text-gray-800 px-2 py-1 rounded disabled:bg-gray-400"
          >
            Capture Payment
          </DropdownMenuItem>
          <DropdownMenuItem
          >
            <div>
              {chat ? <button onClick={() => setChat(undefined)} className='fixed flex justify-center items-center top-0 left-0 z-50 bg-black bg-opacity-25 border shadow-lg w-full h-full overflow-scroll'>
                <div className='bg-white rounded-lg text-start w-96 h-60 p-4 overflow-scroll'>
                  {chat.map(({ message, sender, timestamp }, i) => (
                    <p><b>{sender}</b>: {message} <span className='text-xs'><br />{new Date(timestamp).toLocaleString()}</span></p>
                  ))}
                </div>
              </button> : ""}
              <button onClick={() => fetchChats(row.original._id)} className='underline font-bold'>Chat</button>
            </div>
          </DropdownMenuItem>
          <DropdownMenuItem
            disabled={loadingJobId === row.original._id || !row.original.paymentIntentId}
            onClick={() => handleFetchStripeInfo(row.original)}
            className="hover:bg-gray-600 text-gray-800 px-2 py-1 rounded disabled:bg-gray-400"
          >
            Fetch Stripe Info
          </DropdownMenuItem>
          <DropdownMenuItem
            disabled={row.original.jobStatus !== "in-progress"}
            onClick={() => handleCancel("shoveller")}
            className="hover:bg-gray-600 text-gray-800 px-2 py-1 rounded disabled:bg-gray-400"
          >
            Cancel (Shoveller)
          </DropdownMenuItem>
          <DropdownMenuItem
            disabled={row.original.jobStatus !== "in-progress"}
            onClick={() => handleCancel("admin")}
            className="hover:bg-red-600 text-gray-800 px-2 py-1 rounded disabled:bg-gray-300 disabled:hover:bg-gray-500"
          >
            Cancel (Admin)
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ConfirmationModal
        showModal={showCancelModal}
        onClose={() => setShowCancelModal(false)}
        onConfirm={handleCapture}
        title="Capture Payment"
        message="Are you sure you want to capture the paymnent for this job?"
      />
      {renderPaymentDialog()}

    </Dialog>
  );
}



export const actionColumns = [

  {
    header: "Actions",
    id: "actions",
    cell: ({ row }) => (<Action row={row} />),
  }
];
